import React from 'react';
import { useAppSelector } from '../../../store';
import { Browser } from '../../models/Browsers';

interface PageProps {
  isLastpage: boolean;
  children: React.ReactNode;
}

const Page: React.FC<PageProps> = ({ children, isLastpage }) => {
  const browser = useAppSelector((state) => state.assemblyEditorSlice.browser);
  const isFirefox = browser === Browser.Firefox;

  return (
    <div
      className={`${isFirefox ? 'py-2 px-4' : ''} f-col f1-center f-full`}
      style={{
        breakAfter: 'auto',
        pageBreakAfter: 'auto',
        minHeight: isLastpage ? 'auto' : (isFirefox ? 792 : 718),
        height: 'auto',
        width: '100%',
        position: 'relative'
      }}>
      <div className="f-col f-full" style={{ breakInside: 'avoid', pageBreakInside: 'avoid' }}>
        {children}
      </div>
    </div>
  );
};

export default Page;
